import { type JSX } from 'react';

import logoFull from '@/assets/logo/logo-full.svg';
import logoIcon from '@/assets/logo/logo-icon.svg';
import { useHomeRoute } from '@/hooks/useHomeRoute';

import { LogoLinkFactory } from './Logo.factory';

export function Logo(): JSX.Element {
  const homeRoute = useHomeRoute();
  return (
    <LogoLinkFactory to={homeRoute}>
      {/* data-attributes usados como seletores no recipe — width/height são atributos HTML nativos */}
      <img
        data-logo-full
        src={logoFull}
        alt='Redação nota 1000'
        width={120}
        height={24}
      />
      <img
        data-logo-icon
        src={logoIcon}
        alt='Redação nota 1000'
        width={36}
        height={36}
      />
    </LogoLinkFactory>
  );
}
